<template>
    <div class="Branch">
        <headers :title="$t('分公司')" img="Branch"></headers>
        <div class="main">
            <el-row :gutter="30">
                <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:6,offset:6}"><div class="Branch_img"></div></el-col>
                <el-col :xs="{span:18,offset:3}" :sm="{span:18,offset:3}" :md="{span:6,offset:0}">
                    <div class="Branch_txt">
                        <p>{{$t('河南富凯防护制品有限公司')}}</p>
                        <div class="info">
                            <img src="../../public/img/icon_dian.png" alt="" srcset="">
                            <p>{{$t('成立于2018年5月')}}</p>
                        </div>   
                        <div class="info">
                            <img src="../../public/img/icon_dian.png" alt="" srcset="">
                            <p>{{$t('位于河南驻马店')}}</p>
                        </div>   
                        <div class="info">
                            <img src="../../public/img/icon_dian.png" alt="" srcset="">
                            <p>{{$t('以生产一次性防护用品为主')}}</p>
                        </div>                    
                    </div>
                </el-col>
            </el-row>
        </div>
        <foot></foot>
    </div>
</template>
<script>
import headers from "@/components/headers.vue";
import foot from "@/components/foot.vue";
export default {
    components:{
        headers,foot
    },
}
</script>
<style lang="less">
.Branch{
    width: 100%;
    .main{
        // min-height: 600px;
        width: 100%;
        padding: 3rem 0;
        padding-bottom: 12rem;
        .Branch_img{
            width: 100%;
            height: 200px;
            background: url('../../public/img/BranchPhoto.jpg') no-repeat;
            background-size: cover;
            background-position: center;
            margin-top: 30px;
        }
        .Branch_txt{
            padding: 1px;
            width: 100%;
            height: 230px;
            color: #017CA8;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            margin: 0 auto;
            .info{
                display: flex;
                align-items: center;
                p{
                    font-size: 0.7rem;
                    line-height: 0.7rem;
                    margin-left: 0.7rem;
                    color: #4C4C4C;
                }
            }
        }
    }
}
</style>

<i18n>
{
  "en": {
      "分公司":"Branch",
      "河南富凯防护制品有限公司":"Henan Fukai Protective Products .",
      "成立于2018年5月":"Established in May 2018",
      "位于河南驻马店":"Located in Zhumadian, Henan",
      "以生产一次性防护用品为主":"Mainly produces disposable protective equipment"
  },
  "zh": {
      "分公司":"分(子)公司",
      "河南富凯防护制品有限公司":"河南富凯防护制品有限公司",
      "成立于2018年5月":"成立于2018年5月",
      "位于河南驻马店":"位于河南驻马店",
      "以生产一次性防护用品为主":"以生产一次性防护用品为主"
      
  }
}
</i18n>

